module.exports = __webpack_public_path__ + "img/Heavy-haulage.5f83a5b.jpg";